export const getTimeOperatorAndStartEndAt = (
  startAt?: string | null,
  endAt?: string | null
) => {
  const timeOperator = determineTimeOperator(startAt, endAt);
  if (timeOperator === "Not Between") {
    return { startAt: endAt ?? null, endAt: startAt ?? null, timeOperator };
  }

  return { startAt: startAt ?? null, endAt: endAt ?? null, timeOperator };
};

const determineTimeOperator = (
  startAt?: string | null,
  endAt?: string | null
) => {
  if (!startAt && !endAt) return "ANY";
  if (!startAt && !!endAt) return "Before";
  if (!!startAt && !endAt) return "After";

  if (startAt && endAt) {
    if (startAt < endAt) {
      return "Between";
    } else {
      return "Not Between";
    }
  }
};
